var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "23",
        height: "23",
        viewBox: "0 0 23 23",
      },
    },
    [
      _c("g", { attrs: { fill: "none", "fill-rule": "evenodd" } }, [
        _c("path", { attrs: { d: "M0 0h22.167v22.167H0z" } }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            fill: _vm.color,
            d: "M14.083 3l2.125 2.124-2.67 2.651 1.312 1.312 2.65-2.67\n        2.125 2.125V3h-5.542zM3 8.542l2.124-2.125 2.651 2.67 1.312-1.312-2.67-2.65L8.542\n        3H3v5.542zm5.542 11.083l-2.125-2.124 2.67-2.651-1.312-1.312-2.65 2.67L3\n        14.083v5.542h5.542zm11.083-5.542l-2.124 2.125-2.651-2.67-1.312 1.312\n        2.67 2.65-2.125 2.125h5.542v-5.542z",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }